export const syndEnum = {
  BingYahooAndSearchPartners: 'BingYahooAndSearchPartners',
  BingYahooOnly: 'BingYahooOnly',
  SearchPartnersOnly: 'SearchPartnersOnly',
  InHousePromotion: 'InHousePromotion',
};
